import React from "react";
import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { CONTACT, NAV_LINKS } from "../../lib/data";
import logoWhite from "../../assets/logo-white-transparent.png";

export const Footer = ({ onNav }) => (
  <footer style={{ background: "var(--black)", color: "#e9e9e6", padding: "80px 0 30px" }} data-testid="site-footer">
    <div className="container">
      <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 1fr 1.2fr", gap: 40,
        paddingBottom: 50, borderBottom: "1px solid rgba(255,255,255,0.1)" }} className="footer-grid">
        <div>
          <button onClick={() => onNav("home")} style={{ display: "flex", alignItems: "center", gap: 10, color: "#fff",
            fontFamily: "'Bebas Neue'", fontSize: 26, letterSpacing: "0.08em" }}>
            <img src={logoWhite} alt="VLA lion crest" style={{ width: 42, height: 42, objectFit: "contain" }} /> VLA
          </button>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, marginTop: 16, maxWidth: 280 }}>
            Victorious Lions Academy — building confident, disciplined, and physically strong individuals through martial arts and functional fitness.
          </p>
        </div>
        <div>
          <h5 style={{ fontFamily: "'Inter'", fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase",
            color: "var(--gold)", marginBottom: 20, fontWeight: 800 }}>Quick Links</h5>
          <ul style={{ display: "grid", gap: 12 }}>
            {NAV_LINKS.slice(0, 4).map((l) => (
              <li key={l.id}><button onClick={() => onNav(l.id)} style={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>{l.label}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <h5 style={{ fontFamily: "'Inter'", fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase",
            color: "var(--gold)", marginBottom: 20, fontWeight: 800 }}>Programs</h5>
          <ul style={{ display: "grid", gap: 12 }}>
            {["Boxing", "Kickboxing", "Taekwondo", "Self Defence"].map((p) => (
              <li key={p}><button onClick={() => onNav("programs")} style={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>{p}</button></li>
            ))}
          </ul>
        </div>
        <div>
          <h5 style={{ fontFamily: "'Inter'", fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase",
            color: "var(--gold)", marginBottom: 20, fontWeight: 800 }}>Get In Touch</h5>
          <ul style={{ display: "grid", gap: 12 }}>
            <li><a href={`tel:+${CONTACT.phoneRaw}`} style={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>{CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} style={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>{CONTACT.email}</a></li>
            <li><a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" style={{ fontSize: 14, color: "rgba(255,255,255,0.7)" }}>{CONTACT.instagramHandle}</a></li>
          </ul>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 26,
        flexWrap: "wrap", gap: 14 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <span style={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }}>© {new Date().getFullYear()} Victorious Lions Academy. All rights reserved.</span>
          <span style={{ fontSize: 11.5, color: "rgba(255,255,255,0.28)", letterSpacing: "0.04em" }}
            data-testid="footer-credit">Designed &amp; Built by Mihir Jadhav</span>
        </div>
        <div style={{ display: "flex", gap: 18, alignItems: "center", flexWrap: "wrap" }}>
          <a href="/privacy-policy" data-testid="footer-privacy-link"
            style={{ fontSize: 12.5, color: "rgba(255,255,255,0.6)", letterSpacing: "0.03em" }}>Privacy Policy</a>
          <a href="/terms-and-conditions" data-testid="footer-terms-link"
            style={{ fontSize: 12.5, color: "rgba(255,255,255,0.6)", letterSpacing: "0.03em" }}>Terms &amp; Conditions</a>
          <div style={{ display: "flex", gap: 12 }}>
            {[
              { icon: <Instagram size={16} />, href: CONTACT.instagram },
              { icon: <Facebook size={16} />, href: CONTACT.instagram },
              { icon: <MessageCircle size={16} />, href: `https://wa.me/${CONTACT.phoneRaw}` },
            ].map((s, i) => (
              <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" className="footer-social-icon"
                style={{ width: 38, height: 38, borderRadius: "50%", background: "rgba(255,255,255,0.08)",
                  display: "flex", alignItems: "center", justifyContent: "center", color: "#fff" }}>{s.icon}</a>
            ))}
          </div>
        </div>
      </div>
    </div>
  </footer>
);
